export default "__VITE_PUBLIC_ASSET__6dec0ffb__"